import { generatePath, Navigate, useLocation, useParams } from "react-router";

type Props = {
  to: string;
};

export const RedirectWithParams = ({ to }: Props) => {
  const params = useParams();
  const { search, hash } = useLocation();

  return <Navigate replace to={{ pathname: generatePath(to, params), search, hash }} />;
};
